var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.633,
    height: 20.475,
    viewBox: "0 0 26.633 20.475",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email",
    transform: "translate(-230 -344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_11854",
    "data-name": "Path 11854",
    transform: "translate(231 345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11951",
    "data-name": "Path 11951",
    d: "M4.233,0H20.4a4.233,4.233,0,0,1,4.233,4.233V14.241A4.233,4.233,0,0,1,20.4,18.475H4.233A4.233,4.233,0,0,1,0,14.241V4.233A4.233,4.233,0,0,1,4.233,0Z",
    transform: "translate(0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11952",
    "data-name": "Path 11952",
    d: "M4.234,0H20.4a4.234,4.234,0,0,1,4.234,4.234V14.241A4.234,4.234,0,0,1,20.4,18.475H4.234A4.234,4.234,0,0,1,0,14.241V4.234A4.234,4.234,0,0,1,4.234,0Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fdb713",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10465",
    "data-name": "Group 10465",
    transform: "translate(235.514 349.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11851",
    "data-name": "Path 11851",
    d: "M5078.2-715.068l7.575,6.064,7.722-6.064",
    transform: "translate(-5078.085 715.068)",
    fill: "none",
    stroke: "#fdb713",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11852",
    "data-name": "Path 11852",
    d: "M5081.615-692.445l-5.025,5.03",
    transform: "translate(-5076.59 696.799)",
    fill: "none",
    stroke: "#fdb713",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11853",
    "data-name": "Path 11853",
    d: "M5076.59-692.445l5.029,5.028",
    transform: "translate(-5066.004 696.799)",
    fill: "none",
    stroke: "#fdb713",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.262fb84441732a6aa702dc15c65aa0c8.svg";
export { ForwardRef as ReactComponent };